import { lazy } from 'react';
import { PrivateRoute } from '../../components/PrivateRoute/PrivateRoute';
import { baseUrls } from '../../constants/urls';
const AccountSetupPage = lazy(() => import('./pages/AccountSetupPage/AccountSetupPage'));
const AccountApplicationRequestsPage = lazy(() => import('./pages/AccountApplicationRequestsPage/AccountApplicationRequestsPage'));
const ContinueOnAdobeSignPage = lazy(() => import('./pages/ContinueOnAdobeSignPage/ContinueOnAdobeSignPage'));
const AsrRoutes = [
  <PrivateRoute path={baseUrls.newKybSubmission} exact={true} permissions="accountOpeningFormEnabled" key="accountSetupPage">
    <AccountSetupPage />
  </PrivateRoute>,
  <PrivateRoute path={baseUrls.kybRequests} exact={true} permissions="accountOpeningFormEnabled" key="accountApplicationRequests">
    <AccountApplicationRequestsPage />
  </PrivateRoute>,
  <PrivateRoute path={baseUrls.signDocument} exact={true} permissions="accountOpeningFormEnabled" key="signDocument">
    <ContinueOnAdobeSignPage />
  </PrivateRoute>
];

export default AsrRoutes;
